export const conditionSetEntrySchema = {
  '$id': '/conditionsetentry',
  type: 'object',
  properties: {
    step: { 'type': 'number' },
    condition: { 'type': 'number' },
  },
  'required': [
    'step',
    'condition',
  ],
  'additionalProperties': false
}

const ruleSchema = {
  '$id': '/rule',
  type: 'object',
  properties: {
    id: { 'type': 'string', 'format': 'uuid' },
    name: { 'type': 'string' },
    orgId: { 'type': 'string', 'format': 'uuid' },
    status: { 'type': 'number' },
    conditionSet: { 'type': 'array', 'items': { '$ref': '/conditionsetentry' } },
    tags: { 'type': 'array', 'items': { 'type': 'string' } },
  },
  'required': [
    'status',
    'conditionSet',
    'name',
  ],
  'additionalProperties': false
}

export default ruleSchema
